import type { Destination } from '../../../ui/arche/primitives/Destination';
import type { SkinDestination } from '../../../ui/shared/interfaces/SkinDestination';
import { Context } from '../../../ui/shared/enums/Context';
import { UnderLineType } from '../../../ui/shared/enums/UnderLineType';
import { ComponentType } from '../../../ui/shared/enums/ComponentType';
import { AriaHidden } from '../../../ui/shared/enums/AriaHidden';
import { AriaDisabled } from '../../../ui/shared/enums/AriaDisabled';

/**
 * Default configurations for destination types (functional only)
 * Includes only truly shared properties to avoid type conflicts with specialized types
 */
export const defaultBaseDestination: Partial<Destination> = {
  // Base
  id: 0,
  text: '',

  // BaseControls
  isDisabled: false,
  isActive: false,
  isFocused: false,
  tabIndexValue: undefined,
  ariaCurrent: undefined,
  ariaControls: undefined,
  isExpanded: undefined,
  icon: undefined,
  isVisible: true,

  // Accessibility
  ariaLabel: '',
  ariaDescribedBy: undefined,
  ariaHidden: AriaHidden.False,
  ariaDisabled: AriaDisabled.False,
  role: undefined,
  tabIndex: undefined,
  focusable: true,

  // Destination (Strictly shared part)
  link: '',
  label: '',
  componentType: ComponentType.Internal,
};

/**
 * Default configurations for destination skins
 */
export const defaultBaseSkin: Partial<SkinDestination> = {
  hoverColor: '',
  isUnderLine: UnderLineType.Underline,
  linkColor: Context.None,
};

/**
 * Placeholder configurations for destination types, for use in testing or development
 */
export const placeholderBaseDestination: Partial<Destination> = {
  // Base
  id: 1,
  text: 'Some Descriptive Text For The Destination',

  // BaseControls
  isDisabled: false,
  isActive: true,
  isFocused: false,
  tabIndexValue: 0,
  ariaCurrent: 'page',
  ariaControls: 'content-id',
  isExpanded: false,
  icon: 'arrow-right',
  isVisible: true,

  // Accessibility
  ariaLabel: 'Some descriptive accessibility label',
  ariaDescribedBy: 'description-id',
  ariaHidden: AriaHidden.False,
  ariaDisabled: AriaDisabled.False,
  tabIndex: 0,
  focusable: true,

  // Destination
  link: 'https://domain/some-destination',
  label: 'Some destination Label',
  componentType: ComponentType.Internal,
};

/**
 * Placeholder configurations for destination skins
 */
export const placeholderBaseSkin: Partial<SkinDestination> = {
  hoverColor: 'var:primary',
  isUnderLine: UnderLineType.Underline,
  linkColor: Context.Primary,
};
